import { ArrowRightOutlined } from "@ant-design/icons";
import { Radio } from "antd";
import { styled } from "styled-components";
import "./css/quote-radio.scss";
import ImageWithSpinner from "../ImageWithSpinner";

type QuoteRadio = {
  value: string;
  label: string;
  img: string;
  isSelected: boolean;
};

const QuoteRadio = ({ value, label, img, isSelected }: QuoteRadio) => {
  return (
    <StyledRadio value={value} key={value}>
      <div className={`quote-radio ${isSelected ? "quote-radio--selected" : ""}`}>
        <div className="quote-radio__image-wrap">
          <ImageWithSpinner
            src={img}
            alt={label}
            className="quote-radio__image"
          />
        </div>
        <div className="quote-radio__label">
          <span>{label}</span>
          <span className="quote-radio__label-arrow">
            <ArrowRightOutlined />
          </span>
        </div>
      </div>
    </StyledRadio>
  );
};

export default QuoteRadio;

export const StyledRadio = styled(Radio)`
  .ant-radio {
    display: none;
  }
`;
